
































































import Vue from "vue";
import { MemberManagerService } from "@/common/api/services/MemberManagerService";
import Component from "vue-class-component";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
@Component({
  name: "Register",
  components: {
    QErrors,
  },
})
export default class Register extends Vue {
  isShow = false;
  registerForm = {
    email: "",
    password: "",
    nameMember: "",
  };
  errors = {};

  async submit() {
    let response;
    try {
      response = await MemberManagerService.register(this.registerForm);
    } catch (error: any) {
      response = error.body;
    }

    if (response.status == "error") {
      this.errors = response.errors;
      console.log(this.errors);
      QNotify.error({
        text: response.message,
      });
      return;
    }

    QNotify.success({
      text: response.message,
    });
    this.isShow = false;

    return;
  }

  show() {
    this.isShow = true;
    this.reset();
  }

  close() {
    this.isShow = false;
  }

  reset() {
    this.errors = {};
    this.registerForm = {
      email: "",
      password: "",
      nameMember: "",
    };
  }
}
